import reduxReducerHelper, { mapDefaultValuesToActions } from '../../utils/reduxReducerHelperUtil';

import { appInstancesStates } from '../../hooks/useAppInstancesHook';

const appInstanceActions = mapDefaultValuesToActions(appInstancesStates);

export default reduxReducerHelper(appInstanceActions, appInstancesStates);
